// extracted by mini-css-extract-plugin
export default {"Outlet":"MainLayout_Outlet__s-F-a","Main":"MainLayout_Main__xfdkZ"};